import React from 'react';
import PropTypes from 'prop-types';
import Parser from 'html-react-parser';
import { Container, Row, Col, Tab, Nav, Image } from 'react-bootstrap';
import '../../../assets/scss/sections/_healthcare.scss';

const HealthCare = ({ healthcare_business_data, setting_data }) => {
  return (
    <>
      <section id="healthcare_wrapper">
        <Container>
          <h3 className="main_common_title Healthcare_title text-center">
            <span className="common_span">
              {setting_data?.home_page_healthcare_businesses_title_1}
            </span>
            {setting_data?.home_page_healthcare_businesses_title_2}
          </h3>
          <Row>
            <Col className="healthcare_main_column">
              <Tab.Container id="healthcare_main_container" defaultActiveKey="first">
                <Row>
                  <Col sm={12}>
                    <div className="healthcare_tabing">
                      <Nav variant="pills" className="healthcare_tabs">
                        {healthcare_business_data.map((team, index) => (
                          <Nav.Item key={team.home_healthcare_business_id.toString()}>
                            <Nav.Link
                              eventKey={
                                index === 0 ? 'first' : team.home_healthcare_business_id.toString()
                              }>
                              {team.title}
                            </Nav.Link>
                          </Nav.Item>
                        ))}
                      </Nav>
                    </div>
                  </Col>
                </Row>
                <div className="health_care_wrapper">
                  <Row className="health_care_main_row align-items-center">
                    <Col xl={8} lg={6}>
                      <div className="healthcare_content_wrapper">
                        <Tab.Content className="healthcare_content">
                          {healthcare_business_data.map((team, index) => (
                            <Tab.Pane
                              key={team.home_healthcare_business_id.toString()}
                              eventKey={
                                index === 0 ? 'first' : team.home_healthcare_business_id.toString()
                              }>
                              <h5 className="healthcare_content_main_title">{team.title}</h5>
                              <p className="healthcare_content_main_content">
                                {Parser(team.description)}
                              </p>
                              <a href="#" className="learn_button healthcare_btn_center d-none">
                                Learn More
                              </a>
                            </Tab.Pane>
                          ))}
                        </Tab.Content>
                      </div>
                    </Col>
                    <Col xl={4} lg={6}>
                      <div className="healthcare_content_wrapper">
                        <Tab.Content className="healthcare_content">
                          {healthcare_business_data.map((team, index) => (
                            <Tab.Pane
                              key={team.home_healthcare_business_id.toString()}
                              eventKey={
                                index === 0 ? 'first' : team.home_healthcare_business_id.toString()
                              }>
                              <div className="healthcare_right_image">
                                <div className="healthcare_right_overlay">
                                  <Image
                                    className="img-fluid healthcare_image"
                                    src={team.image_url}
                                    roundedCircle
                                  />
                                </div>
                              </div>
                            </Tab.Pane>
                          ))}
                        </Tab.Content>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Tab.Container>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
HealthCare.propTypes = {
  healthcare_business_data: PropTypes.array,
  setting_data: PropTypes.object,
};
export { HealthCare };
